import { Storage } from '@ionic/storage';
import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { GeneralService } from './../../services/general.service';
import { GoogleMap } from '@angular/google-maps';

@Component({
  selector: 'shc-choose-location-modal',
  templateUrl: './choose-location-modal.component.html',
  styleUrls: ['./choose-location-modal.component.scss'],
})
export class ChooseLocationModalComponent implements OnInit {
  form: UntypedFormGroup;
  latitude: number;
  longitude: number;
  recentSearches: Array<any>;
  selectedCurrentLocation: boolean;
  searchInit = false;
  center: google.maps.LatLngLiteral;

  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;

  @Input() previousSelectedLat: number;
  @Input() previousSelectedLng: number;

  constructor(
    private generalService: GeneralService,
    private userService: UserService,
    private modalCtrl: ModalController,
    private storage: Storage,
  ) {}

  ngOnInit() {
    this.recentSearches = [];
    this.selectedCurrentLocation = false;
    this.storage.get('location-searches').then((res) => {
      if (res) {
        this.recentSearches = JSON.parse(res);
        this.recentSearches = this.recentSearches.reverse();
      }
    });

    /**
     * If already selected a location then show it before changing
     */
    if (this.previousSelectedLat && this.previousSelectedLng) {
      this.center = {
        lat: this.previousSelectedLat,
        lng: this.previousSelectedLng,
      };
      this.latitude = this.previousSelectedLat;
      this.longitude = this.previousSelectedLng;
    } else {
      this.center = {
        lat: 52.37276,
        lng: 4.893604,
      };
      this.latitude = 52.37276;
      this.longitude = 4.893604;
    }

    this.form = new UntypedFormGroup({
      location: new UntypedFormControl(null),
      latitude: new UntypedFormControl(null),
      longitude: new UntypedFormControl(null),
    });
  }

  /**
   * Get current location
   */
  getCurrentLocation() {
    this.selectedCurrentLocation = true;
    this.generalService.showLoader();
    this.generalService.checkPermission((res) => {
      if (res) {
        if (this.generalService.cordova) {
          this.generalService
            .gpsStatus()
            .then((status) => {
              this.generalService.hideLoader();
              if (status) {
                this.patchLocationValues();
              }
            })
            .catch((error) => this.generalService.hideLoader());
        } else {
          this.generalService.hideLoader();
          this.patchLocationValues();
        }
      } else {
        this.generalService.hideLoader();
      }
    });
  }

  /**
   * get location lat, lng using geo location service
   * and set form fields
   */
  patchLocationValues() {
    this.userService.getCurrentLocation((location) => {
      this.form.patchValue({
        location: location?.location?.subLocality,
        latitude: location.coords.latitude,
        longitude: location.coords.longitude,
      });
      // this.recentSearches.push(this.form.value.location);

      if (!this.selectedCurrentLocation) {
        this.recentSearches.push({
          location: this.form.value.location,
          latitude: this.form.value.latitude,
          longitude: this.form.value.longitude,
        });
      }
      this.storage.set(
        'location-searches',
        JSON.stringify(this.recentSearches),
      );
      this.modalCtrl.dismiss(this.form.value, null, 'locationModal');
    });
  }

  /**
   * It will handle the Location related fields
   * @param address formatted address returned from google
   */
  onFocus() {
    this.searchInit = true;
  }
  focusOut() {
    this.searchInit = false;
  }
  handleAddressChange(address: google.maps.places.PlaceResult) {
    this.map.center = {
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
    };
    this.latitude = address.geometry.location.lat();
    this.longitude = address.geometry.location.lng();
    this.form.patchValue({
      location: address.formatted_address,
      latitude: address.geometry.location.lat(),
      longitude: address.geometry.location.lng(),
    });

    // this.recentSearches.push(this.form.value.location);

    this.recentSearches.push({
      location: this.form.value.location,
      latitude: this.form.value.latitude,
      longitude: this.form.value.longitude,
    });

    this.storage.set('location-searches', JSON.stringify(this.recentSearches));
    this.modalCtrl.dismiss(this.form.value, null, 'locationModal');
  }

  getLocation() {
    console.log(this.form.value);
  }

  selectFromRecent(item: any) {
    const lastIndex = this.recentSearches.length - 1;

    if (
      this.recentSearches[lastIndex].latitude !== item.latitude &&
      this.recentSearches[lastIndex].longitude !== item.longitude
    ) {
      this.recentSearches.push({
        location: item.location,
        latitude: item.latitude,
        longitude: item.longitude,
      });
    }

    this.storage.set('location-searches', JSON.stringify(this.recentSearches));
    this.modalCtrl.dismiss(item, null, 'locationModal');
  }

  close() {
    this.modalCtrl.dismiss(null, null, 'locationModal');
  }
}
